import React, { Component, createRef } from "react";
import {
  StyleSheet,
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  Modal,
  Pressable,
  Platform,
} from "react-native";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import moment from "moment-timezone";
import colors from "../../constants/colors";
import { validateDecimals } from "../../utils";
import {
  readMenuAnchorRectSync,
  computeDropdownMenuPlacement,
  getDropdownViewportHeightPx,
  rectsClose,
  subscribeDropdownAnchorGuards,
} from "../../utils/dropdownMenuAnchor";

export default class DropDown extends Component {
  triggerRef = createRef();

  state = {
    isVisible: false,
    selected: null,
    menuRect: null,
  };
  componentDidMount() {
    const { openList, openDropDown } = this.props;
    if (openList) {
      this.setState({ isVisible: true }, () => this.measureAndOpen(openDropDown));
    }
  }
  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.updated != this.props.updated || nextProps.reset != this.props.reset) {
      this.setState({ selected: nextProps.updated ? nextProps.updated : [] });
    }
    if (nextProps.openList != this.props.openList) {
      if (nextProps.openList) {
        this.setState({ isVisible: true }, () =>
          this.measureAndOpen(nextProps.openDropDown)
        );
      } else {
        this.setState({ isVisible: false, menuRect: null });
      }
    }
    if(nextProps.isDropDownOpened != this.props.isDropDownOpened && !nextProps.isDropDownOpened){
      this.setState({ isVisible: false, menuRect: null });
    }
  }

  measureAndOpen = (openDropDown) => {
    const node = this.triggerRef.current;
    if (!node || typeof node.measureInWindow !== "function") {
      this.setState({ menuRect: { x: 0, y: 0, width: 200, height: 60 } });
      if (openDropDown) openDropDown();
      return;
    }
    requestAnimationFrame(() => {
      const syncRect = readMenuAnchorRectSync(node);
      if (syncRect) {
        this.setState({ menuRect: syncRect }, () => {
          if (openDropDown) openDropDown();
        });
        return;
      }
      node.measureInWindow((x, y, width, height) => {
        this.setState(
          { menuRect: { x, y, width: width || 200, height: height || 60 } },
          () => { if (openDropDown) openDropDown(); }
        );
      });
    });
  };

  applyMenuAnchorIfOpen = () => {
    if (!this.state.isVisible || !this.state.menuRect) return;
    const node = this.triggerRef.current;
    const syncRect = readMenuAnchorRectSync(node);
    if (syncRect) {
      this.setState((prev) => {
        if (!prev.isVisible || !prev.menuRect) return null;
        const p = prev.menuRect;
        if (rectsClose(p, syncRect)) return null;
        return { menuRect: syncRect };
      });
      return;
    }
    if (!node || typeof node.measureInWindow !== "function") return;
    node.measureInWindow((x, y, width, height) => {
      const nextRect = { x, y, width: width || 200, height: height || 60 };
      this.setState((prev) => {
        if (!prev.isVisible || !prev.menuRect) return null;
        const p = prev.menuRect;
        if (rectsClose(p, nextRect)) return null;
        return { menuRect: nextRect };
      });
    });
  };

  closeMenu = (syncParent = true) => {
    this.stopMenuAnchorUpdates();
    const { resetDropDown, isDropDownOpened } = this.props;
    this.setState({ isVisible: false, menuRect: null }, () => {
      if (syncParent && isDropDownOpened && typeof resetDropDown === "function") {
        resetDropDown();
      }
    });
  };

  componentDidUpdate(prevProps, prevState) {
    const showingMenu = this.state.isVisible && !!this.state.menuRect;
    const wasShowingMenu = prevState.isVisible && !!prevState.menuRect;
    if (showingMenu && !wasShowingMenu) {
      this.startMenuAnchorUpdates();
    } else if (!showingMenu && wasShowingMenu) {
      this.stopMenuAnchorUpdates();
    }
  }

  componentWillUnmount() {
    this.stopMenuAnchorUpdates();
  }

  startMenuAnchorUpdates = () => {
    this.stopMenuAnchorUpdates();
    if (Platform.OS === "web" && typeof window !== "undefined" && typeof window.requestAnimationFrame === "function") {
      this._detachAnchorGuards = subscribeDropdownAnchorGuards(
        () => this.triggerRef.current,
        () => this.applyMenuAnchorIfOpen()
      );
      const loop = () => {
        if (!this.state.isVisible || !this.state.menuRect) {
          this.stopMenuAnchorUpdates();
          return;
        }
        this.applyMenuAnchorIfOpen();
        this._anchorRafId = window.requestAnimationFrame(loop);
      };
      this._anchorRafId = window.requestAnimationFrame(loop);
      return;
    }
    this._menuAnchorInterval = setInterval(() => {
      if (!this.state.isVisible || !this.state.menuRect) {
        this.stopMenuAnchorUpdates();
        return;
      }
      const node = this.triggerRef.current;
      if (!node || typeof node.measureInWindow !== "function") return;
      node.measureInWindow((x, y, width, height) => {
        const nextRect = { x, y, width: width || 200, height: height || 60 };
        this.setState((prev) => {
          if (!prev.isVisible || !prev.menuRect) return null;
          const p = prev.menuRect;
          if (rectsClose(p, nextRect)) return null;
          return { menuRect: nextRect };
        });
      });
    }, 50);
  };

  stopMenuAnchorUpdates = () => {
    if (typeof this._detachAnchorGuards === "function") {
      this._detachAnchorGuards();
      this._detachAnchorGuards = null;
    }
    if (this._anchorRafId != null && typeof window !== "undefined" && typeof window.cancelAnimationFrame === "function") {
      window.cancelAnimationFrame(this._anchorRafId);
      this._anchorRafId = null;
    }
    if (this._menuAnchorInterval != null) {
      clearInterval(this._menuAnchorInterval);
      this._menuAnchorInterval = null;
    }
  };

  renderOptionsList = (backgroundColor, options, selectedOption, isRecipe, allLabel, defaultLabel, recipeStyle) => {
    const { onSelect } = this.props;
    return (
      <ScrollView style={{...styles.options, backgroundColor: backgroundColor ? backgroundColor : '#ffff'}} keyboardShouldPersistTaps="handled">
        <TouchableOpacity
          style={styles.item}
          key={0}
          onPress={() => {
            var selected = ["default_lot"];
            onSelect(selected);
            this.setState({ selected: selected, isVisible: false, menuRect: null }, () => {
              const { resetDropDown, isDropDownOpened } = this.props;
              if (isDropDownOpened && typeof resetDropDown === "function") {
                resetDropDown();
              }
            });
          }}
        >
          <Text style={{...styles.label, fontSize: recipeStyle ? 14 : 16}}>{allLabel}</Text>
        </TouchableOpacity>
        {options.map((option, idx) => (
          <TouchableOpacity
            style={styles.item}
            key={idx}
            onPress={() => {
              var found = -1;
              var selected = [];
              if (typeof selectedOption == "object") {
                found = selectedOption.findIndex(selectedO => selectedO?.lot == option?.lot);
                selected = selectedOption;
              }
              if (isRecipe) {
                if (found >= 0) {
                  selected.splice(found, 1);
                } else {
                  selected.push(option);
                }
              } else {
                selected = [option];
              }
              onSelect(selected);
              this.setState({ selected: selected, isVisible: false, menuRect: null }, () => {
                const { resetDropDown, isDropDownOpened } = this.props;
                if (isDropDownOpened && typeof resetDropDown === "function") {
                  resetDropDown();
                }
              });
            }}
          >
            <Text style={{...styles.label, fontSize: recipeStyle ? 14 : 16}}>{option?.lot || option?.lot == "" ? this.renderDetailItem(option) : defaultLabel}</Text>
          </TouchableOpacity>
        ))}
      </ScrollView>
    );
  };

  renderDetailItem(item) {
    const { defaultLabel } = this.props;
    var amount = 0;
    var productionDate = "";
    if (item?.historial) {
      item.historial.map((batch) => {
        productionDate = batch.production_date;
        amount = batch.amount + amount;
      });
    }
    if (amount % 1 > 0 && !validateDecimals(amount.toString())) {
      amount = amount.toFixed(3);
    }
    productionDate = moment(productionDate).format("YYYY-MM-DD")
    return `${item?.lot ? item?.lot : defaultLabel} - ${amount} - ${productionDate}`
  }
  render() {
    const { isVisible, selected, menuRect } = this.state;
    const { options, initialOption, onSelect, defaultComponent, defaultLabel, allLabel, isRecipe, width, openDropDown, backgroundColor, isLast, resetDropDown, recipeStyle } = this.props;
    const selectedOption = selected ? selected : initialOption;

    const viewportH = getDropdownViewportHeightPx();
    const { menuTop, menuMaxHeight } = computeDropdownMenuPlacement(menuRect, viewportH);

    return (
      <View style={styles.container} ref={this.triggerRef} collapsable={false}>
        <TouchableOpacity
          style={{...styles.button, backgroundColor: recipeStyle ? colors.primary : "lightgray", borderRadius: recipeStyle ? 10 : 5, padding: recipeStyle ? 5 : 10, margin: recipeStyle ? 5 : 0}}
          disabled={!options || options?.length == 0}
          onPress={() => {
            if (!defaultComponent) {
              if (!isVisible) {
                this.setState({ isVisible: true }, () => this.measureAndOpen(openDropDown));
              } else {
                this.closeMenu(true);
              }
            }
          }}
        >
          <View style={{ width: width == 'mini' ? '80%' : '90%' }}>
            {
              (selectedOption && typeof selectedOption == "object") && selectedOption.map((selected, idx) => {
                return <Text key={idx} style={{ ...styles.label, paddingLeft: 10, paddingVertical: 10, fontSize: recipeStyle ? 14 : 16, color: recipeStyle ? 'white' : 'black'  }}>{selected == "default_lot" ? allLabel : selected?.lot || selected?.lot == "" ? this.renderDetailItem(selected) : defaultLabel}</Text>
              })
            }
          </View>
          {!recipeStyle && <MaterialCommunityIcons
            name="chevron-down"
            size={30}
            color="#9B9B9B"
            style={styles.icon}
          />}
        </TouchableOpacity>

        <Modal
          visible={isVisible && !!menuRect}
          transparent
          //animationType="fade"
          onRequestClose={() => this.closeMenu(true)}
          statusBarTranslucent
        >
          <Pressable style={styles.modalBackdrop} onPress={() => this.closeMenu(true)} />
          {menuRect ? (
            <View
              style={[
                styles.modalMenu,
                {
                  left: menuRect.x,
                  top: menuTop,
                  width: menuRect.width,
                  maxHeight: menuMaxHeight,
                },
              ]}
              pointerEvents="box-none"
            >
              {this.renderOptionsList(backgroundColor, options, selectedOption, isRecipe, allLabel, defaultLabel, recipeStyle)}
            </View>
          ) : null}
        </Modal>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flexDirection: "column",
    alignSelf: "stretch",
    width: "100%",
    position: "relative",
    overflow: "hidden",
    zIndex: 1,
  },
  modalBackdrop: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: "rgba(0,0,0,0.01)",
  },
  modalMenu: {
    position: "absolute",
    zIndex: 10000,
    elevation: 24,
  },
  button: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    flex: 1,
    borderWidth: 1,
    borderColor: "#e7e7e7",
    borderRadius: 5,
    paddingLeft: 10,
    height: 60,
    backgroundColor: 'lightgray'
  },
  label: {
    fontSize: 16,
    color: "#333",
    fontWeight: "200",
    fontFamily: "Roboto",
    wordBreak: 'break-all',
    width: '100%'
  },
  icon: {
    width: 30,
    height: 30,
    marginRight: 5,
  },
  options: {
    borderStyle: "solid",
    borderWidth: 1,
    borderColor: "#e7e7e7",
    borderRadius: 5,
    borderTopLeftRadius: 0,
    paddingBottom: 5,
    width: "100%",
    maxHeight: 200
  },
  item: {
    paddingLeft: 10,
    paddingVertical: 10,
  },
});
